import { effectiveDpi, type CanonicalDocument, type ImageLayer } from '@besbello/design-core';
import type { Diagnostic } from '../types.js';
import { ruleIdOf, type ValidationContext } from '../rules.js';

/**
 * "300 dpi" no es un contrato: lo es la RESOLUCION EFECTIVA, los pixeles del
 * fichero repartidos sobre los milimetros que ocupa impreso. Una foto de 4000 px
 * a 20 mm sobra; la misma a 400 mm es un borron.
 */
export function validateResolution(doc: CanonicalDocument, ctx: ValidationContext): Diagnostic[] {
  const out: Diagnostic[] = [];
  const ruleId = ruleIdOf(ctx.technique);

  for (const layer of doc.layers) {
    if (layer.kind !== 'image') continue;
    const image = layer as ImageLayer;
    const dpi = effectiveDpi(image);
    if (!Number.isFinite(dpi.min)) continue;

    if (dpi.min < ctx.technique.minEffectiveDpi) {
      out.push({
        code: 'EFFECTIVE_DPI_TOO_LOW',
        severity: 'error',
        layerId: layer.id,
        measured: Number(dpi.min.toFixed(1)),
        expected: ctx.technique.minEffectiveDpi,
        unit: 'dpi',
        ruleId,
      });
    }

    // Aviso separado: la imagen se esta AMPLIANDO respecto a su dpi declarado.
    // Puede seguir cumpliendo el minimo y aun asi perder nitidez.
    const declared = image.intrinsic.dpi;
    if (declared !== undefined && dpi.min < declared * 0.95 && dpi.min >= ctx.technique.minEffectiveDpi) {
      out.push({
        code: 'IMAGE_UPSCALED',
        severity: 'warning',
        layerId: layer.id,
        measured: Number(dpi.min.toFixed(1)),
        expected: declared,
        unit: 'dpi',
        ruleId,
      });
    }
  }

  return out;
}
